import ready from '../ready';
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

ready(() => {
  const swiper = new Swiper('.connect__slider-wrapper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 16,
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 768px
      500: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        centeredSlides: false,
      }
    },
  });
});

ready(() => {
  const swiper = new Swiper('.team-swiper', {
    loop: false,
    slidesPerView: 2,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    },
  });
});